/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */
import {
    RESET_CHECKOUT_FIELDS,
    UPDATE_BILLING_ADDRESS,
    UPDATE_BILLING_ADDRESS_ID,
    UPDATE_BILLING_IS_SAME_AS_SHIPPING,
    UPDATE_CLIENT_TYPE,
    UPDATE_CUSTOM_ADDRESS_EXPANDED,
    UPDATE_PAYMENT_METHOD_CODE,
    UPDATE_SHIPPING_ADDRESS,
    UPDATE_SHIPPING_METHOD_CODE
} from './CheckoutFields.action';

export const addressFields = {
    countryId: 'PL',
    street: []
};

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Reducer/getInitialState */
export const getInitialState = () => ({
    billingAddressFields: addressFields,
    shippingAddressFields: addressFields,
    shippingMethodCode: '',
    paymentMethodCode: '',
    billingSameAsShipping: true,
    billingAddressId: 0,
    clientType: 'private',
    isCustomAddressExpanded: false
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Reducer/CheckoutFieldsReducer */
export const CheckoutFieldsReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case UPDATE_BILLING_ADDRESS:
        const { billingAddressFields } = action;

        return {
            ...state,
            billingAddressFields
        };
    case UPDATE_CUSTOM_ADDRESS_EXPANDED:
        const { isCustomAddressExpanded } = action;

        return {
            ...state,
            isCustomAddressExpanded
        };
    case UPDATE_SHIPPING_ADDRESS:
        const { shippingAddressFields } = action;

        return {
            ...state,
            shippingAddressFields
        };

    case UPDATE_SHIPPING_METHOD_CODE:
        const { shippingMethodCode } = action;

        return {
            ...state,
            shippingMethodCode
        };

    case UPDATE_PAYMENT_METHOD_CODE:
        const { paymentMethodCode } = action;

        return {
            ...state,
            paymentMethodCode
        };

    case UPDATE_BILLING_IS_SAME_AS_SHIPPING:
        const { billingSameAsShipping } = action;

        return {
            ...state,
            billingSameAsShipping
        };

    case UPDATE_BILLING_ADDRESS_ID:
        const { billingAddressId } = action;

        return {
            ...state,
            billingAddressId
        };

    case UPDATE_CLIENT_TYPE:
        const { clientType } = action;

        return {
            ...state,
            clientType,
            billingAddressFields: addressFields,
            shippingAddressFields: addressFields
        };

    case RESET_CHECKOUT_FIELDS:
        return getInitialState();

    default:
        return state;
    }
};

export default CheckoutFieldsReducer;
